// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UUtMv5yl1TICl6YrqSex{margin-bottom:24px}._7qsVHidWhttia1UzAIKW{height:40px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/ui/RegistrationAuthoritySelect/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA,CAEF,uBACE,WAAA","sourcesContent":[".countrySelect {\n  margin-bottom: 24px;\n}\n.textField {\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"countrySelect": `UUtMv5yl1TICl6YrqSex`,
	"textField": `_7qsVHidWhttia1UzAIKW`
};
export default ___CSS_LOADER_EXPORT___;
